import React from "react";
import { CardHeader } from "@mui/material";
import { Handle, Position } from "reactflow";
import { StyledCard } from "./constants";
import SFTypography from "../../typography";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const CardHeaderStyled = styled(CardHeader)(({ theme }) => ({
  padding: "10px",
}));

const SFTypographyStyled = styled(SFTypography)(({ theme }) => ({
  display: "-webkit-box",
  WebkitLineClamp: "1",
  WebkitBoxOrient: "vertical",
}));

const Answer = ({ id, type, data, ...otherProps }) => {
  return (
    <>
      <Handle type="target" position={Position.Top} style={{ opacity: 0 }} />
      <StyledCard hasError={!data.label} elevation={0}>
        <CardHeaderStyled
          disableTypography
          avatar={data.index}
          title={
            <SFTypographyStyled textEllipsis variant="body1">
              {data.label}
            </SFTypographyStyled>
          }
          {...(otherProps.getActions && {
            action: otherProps.getActions({ id, type, data }),
          })}
        />
      </StyledCard>
      <Handle
        type="source"
        position={Position.Bottom}
        id="a"
        style={{ opacity: 0 }}
      />
    </>
  );
};

export default Answer;
